import { HeaderLayoutCenter } from "@components/page-layout/header/header-layout-center";
import { HeaderLayoutLeft } from "@components/page-layout/header/header-layout-left";
import { HeaderLayoutRight } from "@components/page-layout/header/header-layout-right";
import { MainPageLayoutProps } from "@components/page-layout/main-page-layout";
import Grid2 from "@mui/material/Grid2";
import { neutral } from "@flat-ui";
import { HEADER_HEIGHT } from "@utils/ui-utils";

type Props = Pick<
  MainPageLayoutProps,
  | "shouldShowLogo"
  | "topLeftHeaderButton"
  | "topbarBackgroundColor"
  | "shouldShowTopbarBorder"
  | "shouldHideOpenButton"
  | "shouldShowSidebar"
  | "centerComponent"
  | "shouldShowProgressOverviewMenu"
  | "shouldShowUserMenu"
  | "shouldShowBreadcrumbs"
>;

/** Content of the app header */
export function AppHeader({
  shouldShowLogo = false,
  topLeftHeaderButton,
  topbarBackgroundColor = neutral[0],
  shouldShowTopbarBorder,
  shouldHideOpenButton = false,
  shouldShowSidebar = true,
  centerComponent,
  shouldShowProgressOverviewMenu = true,
  shouldShowUserMenu = true,
  shouldShowBreadcrumbs = true,
}: Props): JSX.Element {
  return (
    <Grid2
      container
      sx={{
        // The logo needs a smaller padding on the left side
        pl: shouldShowLogo ? "0.5rem" : "1.125rem",
        pr: "0.5rem",
        py: topLeftHeaderButton ? "0" : "0.375rem",
        maxHeight: "7.5rem",
        minHeight: HEADER_HEIGHT,
        backgroundColor: topbarBackgroundColor,
        borderBottom: shouldShowTopbarBorder ? `1px solid ${neutral[200]}` : "",
      }}
      data-testid="HEADER_CONTAINER"
      alignItems="center"
      justifyContent="space-between"
      flexWrap={topLeftHeaderButton ? "nowrap" : "wrap"}
      width="100%"
      position={"sticky"}
      top={0}
      zIndex={2}
    >
      {/* Left side of the top-bar */}
      <HeaderLayoutLeft
        shouldShowLogo={shouldShowLogo}
        shouldHideOpenButton={shouldHideOpenButton}
        topLeftHeaderButton={topLeftHeaderButton}
        shouldShowSidebar={shouldShowSidebar}
        shouldShowBreadcrumbs={shouldShowBreadcrumbs}
      />

      {/* Center of the top-bar */}
      <HeaderLayoutCenter centerComponent={centerComponent} />

      {/* Right side of the top-bar */}
      <HeaderLayoutRight
        shouldShowProgressOverviewMenu={shouldShowProgressOverviewMenu}
        shouldShowUserMenu={shouldShowUserMenu}
      />
    </Grid2>
  );
}
